<ng-container>
    <pmt-main-layout>
        <app-top-navbar top-navbar></app-top-navbar>

        <app-side-navbar sidebar></app-side-navbar>

        <router-outlet main-content></router-outlet>
    </pmt-main-layout>
</ng-container>